import { LocalStorageService } from '.';

const KEY_NAME = 'session-id';

const userSessionLocalStorageService = new LocalStorageService(KEY_NAME);

export { userSessionLocalStorageService };
